import { render, staticRenderFns } from "./UberEventList.vue?vue&type=template&id=51f5e77b&"
import script from "./UberEventList.vue?vue&type=script&lang=js&"
export * from "./UberEventList.vue?vue&type=script&lang=js&"
import style0 from "./UberEventList.vue?vue&type=style&index=0&id=51f5e77b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QToggle,QBtn,QIcon,QInput,QTable,QTd});
